<ion-app>
  <app-header></app-header>

  <ion-router-outlet id="main"></ion-router-outlet>

  <app-footer></app-footer>
</ion-app>
